import React from 'react';
import { Button, Table, Label } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { isEmpty as _isEmpty } from 'lodash';

import { addNotification } from 'actions/NotificationsActions';
import { deleterDispatchHelper } from 'actions/DeleterActions';

import SimplePrompt from 'components/layout/SimplePrompt';
import Loader from 'components/layout/Loader';
import IntlDateTime from 'components/layout/IntlDateTime';

import List from 'components/List';

import ExternalAccountNew from 'components/modals/ExternalAccountNew';
import ExternalAccountEdit from 'components/modals/ExternalAccountEdit';

import may from 'js/security';

class ClientExternalAccounts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
      showEdit: false,
      shownAccount: null,
    };
  }

  showNew = () => {
    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };

  closeNewAfterSave = () => {
    const {
      intl: { messages },
      doNotify,
    } = this.props;

    this.closeNew();
    doNotify(1, messages.account_saved);
  };

  handleClick = shownAccount => {
    this.setState({ showEdit: true, shownAccount });
  };

  closeEdit = () => {
    this.setState({ showEdit: false, shownAccount: null });
  };

  closeEditAfterSave = () => {
    const {
      intl: { messages },
      doNotify,
    } = this.props;

    this.closeEdit();
    doNotify(1, messages.account_saved);
  };

  handleRemoveClick = (e, accountId) => {
    e.preventDefault();
    e.stopPropagation();

    const { deleteAccount } = this.props;
    deleteAccount(accountId);
  };

  getAccountStatus = account => {
    const {
      intl: { messages },
    } = this.props;

    if (account.too_many_login_fails) {
      return (
        <Label bsStyle="danger">
          <i className="fas fa-exclamation" /> {messages.external_account_status.login_fail}
        </Label>
      );
    }

    if (account.successive_login_fails > 0) {
      return (
        <Label bsStyle="warning">
          <i className="fas fa-exclamation" /> {messages.external_account_status.login_warning}
        </Label>
      );
    }

    if (!_isEmpty(account.last_login_success)) {
      return (
        <Label>
          <i className="fas fa-check" /> {messages.external_account_status.login_valid}
        </Label>
      );
    }
    return '';
  };

  render() {
    const {
      intl: { messages },
      user,
      entity,
      entityLoaded,
      list,
    } = this.props;
    const { showNew, showEdit, shownAccount } = this.state;

    const columns = [
      messages.name,
      messages.type,
      messages.username,
      messages.status,
      messages.external_account_status.last_successful_login,
      messages.external_account_status.last_login_fail_message,
      messages.actions,
    ];
    const tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const account = list.data.list[i];

      tBody.push(
        <tr key={account.id} onClick={() => this.handleClick(account)}>
          <td className="v-align-middle semi-bold">{account.name}</td>
          <td className="v-align-middle">{account.type}</td>
          <td className="v-align-middle">{account.username}</td>
          <td className="v-align-middle">{this.getAccountStatus(account)}</td>
          <td className="v-align-middle">
            {_isEmpty(account.last_login_success) ? '-' : <IntlDateTime date={account.last_login_success} />}
          </td>
          <td className="v-align-middle">
            {_isEmpty(account.last_login_fail_message) ? '-' : account.last_login_fail_message}
          </td>
          <td className="v-align-middle text-right">
            <Button bsSize="sm" className="btn-rounded m-r-10">
              <i className="fa fa-pencil-alt" /> {messages.edit}
            </Button>
            {may('ROLE_ADMIN', user.roles) && (
              <SimplePrompt
                onSuccess={e => {
                  this.handleRemoveClick(e, account.id);
                }}
              />
            )}
          </td>
        </tr>
      );
    }

    const resultTable =
      list.pending || !entityLoaded ? (
        <Loader />
      ) : (
        <Table responsive hover>
          <thead>
            <tr>
              {columns.map((column, i) => {
                return (
                  <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                    {column}
                  </th>
                );
              })}
            </tr>
          </thead>
          <ReactCSSTransitionGroup
            transitionName="tablerows"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={1}
            component="tbody"
          >
            {tBody}
          </ReactCSSTransitionGroup>
        </Table>
      );

    return entityLoaded ? (
      <div className="clearfix padding-20 sm-padding-10">
        <List
          listName="externalAccounts"
          url="/api/externalaccounts.json"
          urlData={may('ROLE_SUPERADMIN', user.roles) ? { filters: { owner: entity.getUsername() } } : null}
          list={list}
          showNew
          newText={messages.add_account}
          newAction={this.showNew}
        >
          {resultTable}

          <div id="external-account-new">
            <ExternalAccountNew
              show={showNew}
              close={this.closeNew}
              onSubmitParent={this.closeNewAfterSave}
              requestData={{ owner: entity.getUsername() }}
            />
          </div>
          <div id="external-account-edit">
            <ExternalAccountEdit
              show={showEdit}
              close={this.closeEdit}
              account={shownAccount}
              onSubmitParent={this.closeEditAfterSave}
              requestData={{ owner: entity.getUsername() }}
            />
          </div>
        </List>
      </div>
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
    list: state.list.externalAccounts,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    deleteAccount: accountId => {
      deleterDispatchHelper('externalAccount', '/api/externalaccounts/' + accountId + '.json', dispatch);
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ClientExternalAccounts)
);
